/* eslint-disable */
import React, { useEffect, useState } from 'react';
import SelectInput from '../select_input/SelectInput.jsx';
import { COHATCH_MARKETS, COHATCH_LOCATIONS, COHATCH_MEETING_ROOMS } from "../../constant.js";
import TimeDropdown from '../Time/TimeDropdown.jsx';

const MEAgreementForm = ({
  market, setMarket,
  location, setLocation,
  room, setRoom,
  meetingDate, setMeetingDate,
  meetingStart, setMeetingStart,
  meetingEnd, setMeetingEnd,
  rate, setRate,
  addendum, setAddendum,
  meetingSlots, setMeetingSlots // ✅ Accept from props
}) => {
  const [rateSuffix, setRateSuffix] = useState("/hr"); // Default suffix

  // Sync main meeting fields to first slot
  useEffect(() => {
    if (meetingSlots.length > 0) {
      setMeetingDate(meetingSlots[0].date);
      setMeetingStart(meetingSlots[0].start);
      setMeetingEnd(meetingSlots[0].end);
    }
  }, [meetingSlots]);

  return (
    <>
      {/* Market Dropdown */}
      <div>
        <label className="block text-sm font-semibold text-gray-700">
          Select COhatch Market <span className="text-danger-500">*</span>
        </label>
        <SelectInput
          options={COHATCH_MARKETS.market}
          value={COHATCH_MARKETS.market.find(item => item.value === market)}
          setSelectedValue={(selected) => {
            setMarket(selected.value);
            setLocation(""); // Reset location on market change
          }}
          placeholder="Choose a market"
          className="mt-1"
          required
        />
      </div>

      {/* Location Dropdown */}
      {market && (
        <div>
          <label className="block text-sm font-semibold text-gray-700">
            Select COhatch Location <span className="text-danger-500">*</span>
          </label>
          <SelectInput
            options={COHATCH_LOCATIONS.cities[0][market]?.locations || []}
            value={
              location
                ? COHATCH_LOCATIONS.cities[0][market]?.locations.find(
                  (item) => item.value === location
                )
                : ""
            }
            setSelectedValue={(selected) => setLocation(selected.value)}
            placeholder="Choose a location"
            className="mt-1"
            required
          />
        </div>
      )}

      {/* Room Dropdown */}
      {location && (
        <div>
          <label className="block text-sm font-semibold text-gray-700">
            Select COhatch Meeting Space <span className="text-danger-500">*</span>
          </label>
          <SelectInput
            options={COHATCH_MEETING_ROOMS[market]?.[location] || []}
            value={
              room
                ? COHATCH_MEETING_ROOMS[market][location].find(
                  (item) => item.value === room
                )
                : ""
            }
            setSelectedValue={(selected) => setRoom(selected.value)}
            placeholder="Choose a meeting space"
            className="mt-1"
            required
          />
        </div>
      )}

      {/* Meeting Slots */}
      {meetingSlots.map((slot, index) => (
        <div key={index} className="border border-gray-200 p-6 rounded-lg shadow-sm bg-white mb-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Meeting Slot {index + 1}
           <span className="text-danger-500">*</span> </h3>
            {index > 0 && (
              <button
                type="button"
                onClick={() =>
                  setMeetingSlots(meetingSlots.filter((_, i) => i !== index))
                }
                className="text-sm text-danger-500 hover:underline"
              >
                Remove
              </button>
            )}
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Meeting Date
              </label>
              <input
                type="date"
                value={slot.date}
                onChange={(e) =>
                  setMeetingSlots((prev) =>
                    prev.map((s, i) =>
                      i === index ? { ...s, date: e.target.value } : s
                    )
                  )
                }
                required
                className="w-full px-3 py-2 border rounded-md text-gray-800 border-gray-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <TimeDropdown
                  label="Start Time"
                  name="start"
                  value={slot.start}
                  onChange={(val) =>
                    setMeetingSlots((prev) =>
                      prev.map((s, i) => (i === index ? { ...s, start: val } : s))
                    )
                  }
                />

              </div>

              <div>
                <TimeDropdown
                  label="End Time"
                  name="end"
                  value={slot.end}
                  onChange={(val) =>
                    setMeetingSlots((prev) =>
                      prev.map((s, i) => (i === index ? { ...s, end: val } : s))
                    )
                  }
                />

              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Add Slot Button */}
      <button
        type="button"
        onClick={() =>
          setMeetingSlots([...meetingSlots, { date: "", start: "", end: "" }])
        }
        className="mt-2 text-primary-400 text-sm"
      >
        + Add Another Meeting Slot
      </button>

      {/* Rate Field */}
      <div className="flex items-center space-x-4 mt-4">
        <div className="flex-1">
          <label htmlFor="rate" className="block text-sm font-semibold text-gray-700">
            Rate <span className="text-danger-500">*</span>
          </label>
          <div className="relative">
            <span className="absolute left-3 top-2.5 text-gray-500">$</span>
            <input
              type="text"
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                const regex = /^[0-9]*\.?[0-9]*$/;
                if (regex.test(rawValue)) {
                  setRate(`${rawValue}${rateSuffix}`);
                }
              }}
              value={rate}
              required
              className="mt-1 pl-6 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
            />
          </div>
        </div>

        {/* Rate Type Dropdown */}
        <div className="w-32">
          <label className="block text-sm font-semibold text-gray-700">
            Rate Type <span className="text-danger-500">*</span>
          </label>
          <select
            onChange={(e) => {
              const suffix = e.target.value === "per_hour" ? "/hr" : " Total";
              const numericValue = rate.replace(/[^0-9.]/g, "");
              setRate(`${numericValue}${suffix}`);
              setRateSuffix(suffix);
            }}
            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
          >
            <option value="per_hour">Per Hour</option>
            <option value="total">Total</option>
          </select>
        </div>
      </div>

      {/* Addendum */}
      <div className="mt-4">
        <label htmlFor="addendum" className="block text-sm font-semibold text-gray-700">
          Addendum (Optional)
        </label>
        <input
          type="text"
          onChange={(e) => setAddendum(e.target.value)}
          value={addendum}
          className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
        />
      </div>
    </>
  );
};

export default MEAgreementForm;
